import { useContext, useState } from "react";
import * as Scrivito from "scrivito";
import I18n from "^/config/i18n";
import { CookieConsentContext } from "../../Components/CookieConsentContext";
import { CookieSwitch } from "./CookieSwitch";

function CookeiOptionsWidget({ widget }) {
  const { options, setOptions } = useContext(CookieConsentContext);
  const [cookie, setCookie] = useState(0);

  const changeOptions = (key, value) => {
    setOptions(key, value);
    setCookie(cookie + 1);
  };

  const allButtonColors = () => {
    const values = Object.values(options);
    if (values.every((value) => value === true)) {
      return ["btn-primary", "btn-outline-primary"];
    }
    if (values.every((value) => value === false)) {
      return ["btn-outline-primary", "btn-primary"];
    }
    return ["btn-outline-primary", "btn-outline-primary"];
  };

  return (
    <div>
      <div className="d-flex flex-column flex-md-row justify-content-end align-items-center py-3 px-0">
        <h6 className="me-2 mb-3 mb-md-0  ">{I18n.t("CookieOptions.all")}</h6>
        <div className="d-flex align-items-center">
          <button
            className={`me-1 btn ${allButtonColors()[0]}`}
            onClick={() => changeOptions("all", true)}
          >
            {I18n.t("CookieOptions.accept")}
          </button>
          <button
            className={`me-1 btn ${allButtonColors()[1]}`}
            onClick={() => changeOptions("all", false)}
          >
            {I18n.t("CookieOptions.deny")}
          </button>
        </div>
      </div>
      <ul className="list-group">
        <li className="list-group-item p-3">
          <CookieSwitch
            widget={widget}
            title=""
            service="technicalNeeded"
            icon="las la-cogs"
            attribute="technicalNeededList"
            disabled={true}
            changeOptions={changeOptions}
          />
        </li>

        <li className="list-group-item p-3">
          <CookieSwitch
            widget={widget}
            title="Youtube"
            service="youtube"
            icon="lab la-youtube"
            attribute="youtubeList"
            changeOptions={changeOptions}
          />
        </li>

        <li className="list-group-item p-3">
          <CookieSwitch
            widget={widget}
            title="Vimeo"
            service="vimeo"
            icon="lab la-vimeo"
            attribute="vimeoList"
            changeOptions={changeOptions}
          />
        </li>

        <li className="list-group-item p-3">
          <CookieSwitch
            widget={widget}
            title="OpenStreetMap"
            service="openstreetmap"
            icon="las la-map-marked-alt"
            attribute="openstreetmapList"
            changeOptions={changeOptions}
          />
        </li>

        <li className="list-group-item p-3">
          <CookieSwitch
            widget={widget}
            title="StudiAssist"
            service="studiassist"
            icon="las la-comment-dots"
            attribute="studiassistList"
            changeOptions={changeOptions}
          />
        </li>

        <li className="list-group-item p-3">
          <CookieSwitch
            widget={widget}
            title="Facebook"
            service="facebook"
            icon="lab la-facebook"
            attribute="facebookList"
            changeOptions={changeOptions}
          />
        </li>

        <li className="list-group-item p-3">
          <CookieSwitch
            widget={widget}
            title="TikTok"
            service="tiktok"
            icon="lab la-tiktok"
            attribute="tiktokList"
            changeOptions={changeOptions}
          />
        </li>

        <li className="list-group-item p-3">
          <CookieSwitch
            widget={widget}
            title="Matomo"
            service="matomo"
            icon="las la-chart-area"
            attribute="matomoList"
            changeOptions={changeOptions}
          />
        </li>
      </ul>
      <div className="overflow-hidden">
        <button
          className="btn bg-blue float-right mt-3"
          onClick={() => window.history.back()}
        >
          <i className="las la-angle-left is-100 pe-2" aria-hidden="true" />
          Back
        </button>
      </div>
    </div>
  );
}

Scrivito.provideComponent(
  "CookeiOptionsWidget",
  Scrivito.connect(CookeiOptionsWidget)
);
